export const timeoutConfig = {
    title : 'Your Session is About to Expire!',
    message : 'Keep Session alive?',
    logoutButton : 'Logout',
    keepAliveButton : 'Stay Connected', 
    keepAliveUrl : [], 
    keepAlivePinged: false, 
    ajaxType : 'GET', 
    ajaxData : '', 
    refreshOnTimeOut : false, 
    redirUrl : '', 
    logoutUrl : '/log-out', 
    warnAfter: 480000, 
    redirAfter: 540000, 
    // warnAfter: 15000 // local,
    // redirAfter: 65000 //loca;, 
    warnOnly : false, 
    keepAliveInterval : 5000,
    keepAliveVal : true,
    ignoreUserActivity : true,
    onWarn : false,
    onRedir : false,
    countdownMessage : '',
    countdownBar : true,
    countdownSmart : true,
    hideModalOnAction : false,
    logoutFunction : false,
    countdown: {},
    countdownWidth: 100,
    countdownText: ''

  };